/** @deprecated Use `ItemConfig` instead. */

export function isGLComponentConfig(item) {
  return item.componentName !== undefined;
}
export function isReactComponentConfig(item) {
  return item.component !== undefined;
}
export var itemDefaultConfig = Object.freeze({
  type: 'default',
  isClosable: true,
  isFocusOnShow: true,
  reorderEnabled: true,
  title: ''
});
//# sourceMappingURL=ItemConfig.js.map